module.exports = __webpack_public_path__ + "static/media/Display Picture.f712ee90.svg";